/**
 * Affiliations Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";
import AppConfig from "@/constants/AppConfig";

// States
const state = {
    etablissementPrestations: [],
    etablissementPrestation: {}
};

// Getters
const getters = {
    etablissementPrestations: state => {
        return state.etablissementPrestations
    },

    etablissementPrestation: state => {
        return state.etablissementPrestation
    }
};

// Actions
const actions = {
    getEtablissementPrestations(context, payload) {
        function successCallback(response) {
            context.commit('getPrestationsHandler', { etablissementPrestations: response.data.prestations });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.EtablissementPrestation.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getEtablissementPrestation(context, payload) {
        function successCallback(response) {
            context.commit('getEtablissementPrestationHandler', { etablissementPrestation: response.data.prestation });
        }

        function errorCallback(error) {

            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.EtablissementPrestation.Get, localToken, successCallback, errorCallback, payload.errorMessages);

    },

    createEtablissementPrestation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'etablissement-prestation', params: { prestation_etablissement: response.data.etablissementPrestation.slug } });
        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.EtablissementPrestation.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createEtablissementPrestationCvs(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'etablissement-prestations-list', params: { prestation_etablissement: response.data.etablissementPrestation.slug } });
        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');
        let url = AppConfig.apiUrl + apiModel.EtablissementPrestation.Import.url;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);

        // makeApiRequest(payload.args, apiModel.EtablissementPrestation.Import, localToken, successCallback, errorCallback, payload.errorMessages,true);
    },

    updateEtablissementPrestation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'etablissementPrestation' });
            router.push({ name: 'etablissement-prestation', params: { etablissementPrestation: response.data.etablissementPrestation.slug } });

        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.EtablissementPrestation.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteEtablissementPrestation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'etablissementPrestation' });
            router.push({ name: 'etablissement-prestations' });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.EtablissementPrestation.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getEtablissementPrestationsHandler(state, { etablissementPrestations }) {
        // Update affiliations state
        state.etablissementPrestations = etablissementPrestations;
    },

    getEtablissementPrestationHandler(state, { etablissementPrestation }) {
        // Update affiliation state
        state.etablissementPrestation = etablissementPrestation;
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}